import theme from '../../theme';

const WeatherFog = ({ color = theme.colors.gray, width = '22', height = '22' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.00009 14.899C3.25714 14.1399 2.69666 13.2217 2.36113 12.2139C2.0256 11.2062 1.9238 10.1352 2.06346 9.08229C2.20311 8.02935 2.58055 7.02199 3.16719 6.13652C3.75383 5.25106 4.53428 4.5107 5.44943 3.97154C6.36458 3.43238 7.39042 3.10854 8.44926 3.02457C9.5081 2.94059 10.5722 3.09868 11.5609 3.48685C12.5496 3.87502 13.4369 4.4831 14.1558 5.26503C14.8747 6.04695 15.4062 6.98222 15.7101 7.99999H17.5001C18.4656 7.99988 19.4056 8.31031 20.1811 8.88543C20.9566 9.46055 21.5266 10.2699 21.8069 11.1938C22.0871 12.1177 22.0628 13.1073 21.7374 14.0164C21.4121 14.9254 20.803 15.7057 20.0001 16.242"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M16 17H7" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17 21H9" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default WeatherFog;
